<template>
    <div class="knvb-subgame-finder__wrapper">
        <article class="subgame-finder knvb-subgame-finder">
            <div class="subgame-finder__background knvb-subgame-finder__background"></div>
            <div class="subgame-finder__inner knvb-subgame-finder__inner">
                <h1 class="subgame-finder__title knvb-subgame-finder__title">{{ formattedTitle }}</h1>
                <p class="subgame-finder__description">{{ formattedDescription }}</p>
                <div class="subgame-finder__selector">
                    <span class="subgame-finder__label">{{ label }}</span>
                    <div class="subgame-finder__input-wrapper">
                        <input
                            ref="input"
                            v-model="searchTerm"
                            class="subgame-finder__input"
                            type="text"
                            :placeholder="placeholder"
                            @focus="setFocus(true)"
                            @blur="setFocus(false)"
                            @input="e => (searchTerm = e.target.value)"
                        />
                        <template v-if="focussed">
                            <ul class="subgame-finder__results" :style="{ maxWidth: dropdownMaxWidth }">
                                <template v-if="hasSubGames">
                                    <li
                                        v-for="(subGame, index) in subGamesList"
                                        :key="index"
                                        class="subgame-finder__result"
                                        @mousedown="selectSubGame(subGame.slug)"
                                    >
                                        {{ subGame.name }}
                                        <span class="subgame-finder__result-loc">{{ subGame.city }}</span>
                                    </li>
                                </template>
                                <template v-else>
                                    <li class="subgame-finder__result">
                                        Geen resultaat
                                    </li>
                                </template>
                            </ul>
                        </template>
                    </div>
                </div>
                <SccLink
                    ref="button"
                    :to="url"
                    class="subgame-finder__button knvb-subgame-finder__button"
                    :class="disabled ? 'knvb-subgame-finder__button--disabled' : ''"
                    :disabled="disabled"
                >
                    <span>{{ ctaText }}</span>
                    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1.48861 14.4443L8.55889 7.33308L1.48861 0.221835L0.60498 1.11058L6.79163 7.33308L0.60498 13.5556L1.48861 14.4443Z"
                            fill="white"
                        />
                    </svg>
                </SccLink>
            </div>
        </article>
        <article class="knvb-subgame-finder__prize-wrapper">
            <div class="knvb-subgame-finder__prize">
                <h2 class="knvb-subgame-finder__heading">Hoofdprijs</h2>
                <p class="knvb-subgame-finder__prize-block">
                    <span class="knvb-subgame-finder__amount">€5.000,-</span>
                    <span class="knvb-subgame-finder__detail">Voor jou</span>
                </p>
                <p class="knvb-subgame-finder__spacer">/</p>
                <p class="knvb-subgame-finder__prize-block">
                    <span class="knvb-subgame-finder__amount">€5.000,-</span>
                    <span class="knvb-subgame-finder__detail">Voor je club</span>
                </p>
            </div>
        </article>
    </div>
</template>

<script>
import './knvb-subgame-finder.scss';
import { ticketSaleOpen } from './../../../../utils/data-conversions';
// import SccLink from '../global/SccLink';

export default {
    name: 'KNVBSubgameFinder',
    props: {
        title: {
            type: String,
            default: 'Heading',
        },
        description: {
            type: String,
            default: 'Description',
        },
        label: {
            type: String,
            default: 'Label',
        },
        placeholder: {
            type: String,
            default: 'Placeholder',
        },
        cta: {
            type: String,
            default: 'CTA',
        },
        game: {
            type: Object,
            required: true,
        },
        subGames: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data: () => {
        return {
            searchTerm: '',
            slug: undefined,
            path: undefined,
            focussed: false,
            currentName: undefined,
        };
    },
    __editor: {
        requiredData: ['game', 'subGames'],
        fields: {
            title: {
                widget: 'text',
                default: 'Onze sponsoren',
            },
            description: {
                widget: 'textarea',
                default: 'Description',
            },
            label: {
                widget: 'text',
                default: 'Label',
            },
            placeholder: {
                widget: 'text',
                default: 'Placeholder',
            },
            cta: {
                widget: 'text',
                default: 'CTA',
            },
        },
    },
    computed: {
        ticketSaleOpen() {
            return ticketSaleOpen(this.game);
        },
        subGamesList() {
            return this.filterSubGames(this.subGames, this.searchTerm);
        },
        hasSubGames() {
            return this.subGamesList.length > 0;
        },
        disabled() {
            // return true
            return this.url === '/';
            // return this.url ? '' : 'subgame-finder__button--disabled';
        },
        url() {
            if (this.path && this.slug && this.currentName === this.searchTerm) {
                let url = `/${this.path}/${this.slug}`;
                return this.ticketSaleOpen ? url : url + '/trekkingsuitslag';
            }
            return '/';
        },
        dropdownMaxWidth() {
            return this.$refs?.input?.clientWidth + 'px' || '240px';
        },
        formattedTitle() {
            if (this.ticketSaleOpen) return this.title;
            else return 'DE UITSLAG IS BEKEND!';
        },
        formattedDescription() {
            if (this.ticketSaleOpen) return this.description;
            else return 'Selecteer jouw club en bekijk of je in de prijzen bent gevallen.';
        },
        ctaText() {
            if (this.ticketSaleOpen) return this.cta;
            else if (this.disabled) return 'Selecteer een club';
            else return 'Bekijk trekkingsuitslag';
        },
    },
    methods: {
        setFocus(value) {
            setTimeout(() => {
                if (!value) this.$refs.button.$el.focus();
                this.focussed = value;
            }, 100);
        },
        selectSubGame(slug) {
            const currentSubGame = this.getCurrentClub(slug);
            this.slug = slug;
            this.searchTerm = currentSubGame.name;
            this.currentName = currentSubGame.name;
            this.path = currentSubGame.path;
        },
        getCurrentClub(slug) {
            return this.subGames.find(game => game.slug === slug);
        },
        filterSubGames(subGames, searchTerm) {
            if (searchTerm === '') return subGames;

            return subGames.filter(({ name, city }) => {
                return (
                    name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    city.toLowerCase().includes(searchTerm.toLowerCase())
                );
            });
        },
    },
};
</script>
